/** Home page mobile carousel
 */

$(function () {
  $('.show-neighbors .carousel-item').each(function () {
    var next = $(this).next()
    if (!next.length) {
      next = $(this).siblings(':first')
    }
    next.children(':first-child').clone().appendTo($(this))
  }).each(function () {
    var prev = $(this).prev()
    if (!prev.length) {
      prev = $(this).siblings(':last')
    }
    prev.children(':nth-last-child(2)').clone().prependTo($(this))
  });

  // Remove hand swipe icon on first slide
  $('.show-neighbors').on('slide.bs.carousel', function onSlide (ev) {
    if (ev.to > 0) {
      if ($('.hand-swipe').length) {
        $('.hand-swipe').fadeOut(300 , function() {
          $(this).remove()
        });
      }
    }
  });

  // var d = $('.show-neighbors .carousel-card'),
  //   tallestDivHeight = 0
  
  // d.each(function () {
  //   var t = $(this),
  //     thisDivsHeight = t.outerHeight()

  //   console.log(thisDivsHeight)
  //   if (thisDivsHeight > tallestDivHeight) tallestDivHeight = thisDivsHeight
  // })

  // d.css('height', tallestDivHeight)
});



// WEBPACK FOOTER //
// ./scripts/routes/carousel.js